exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MuiContainer-root.ap-container {\n  max-width: inherit;\n  padding: 2em;\n  border-radius: 8px;\n  height: 100%;\n}\n\n.ap_search_bar {\n  display: flex;\n  align-items: center;\n  width: 378px;\n  height: 44px;\n  padding: 10px 14px 10px 14px;\n  border: 1px solid #D0D5DD;\n  border-radius: 8px;\n  gap: 8px;\n  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.0509803922);\n  margin-bottom: 10px;\n  margin-top: 10px;\n  background-color: White;\n}", ""]);

// exports
